import { Periodo } from "./Periodo";
import { PlanoRefeicao } from "./PlanoRefeicao";
import { PlanoStatus } from "./PlanoStatus";

export class PlanoAlimentar {
  idPlanoAlimentar!: number;
  idPessoa?: number;
  caracteristicas?: any;
  condicoesClinicas?: string;
  status!: PlanoStatus;
  criador?: string;
  periodo!: Periodo;
  observacoes?: string;
  consumoAguaMl!: number;
  refeicoes?: PlanoRefeicao[];
}
